import { Description } from '@headlessui/react'
import { useState } from 'react'
import { Form, useSubmit } from 'react-router'
import { ActionBar, CancelButton, ContinueButton } from '~/components/ActionBar'
import { Alert } from '~/components/Alert'
import { Button } from '~/components/Button'
import { Dialog, DialogTitleWithCloseButton } from '~/components/Dialog'
import { Input } from '~/components/Input'
import { ChangePasswordEnum } from '~/dashboard/ChangePassword'
import { recaptchaPrecheckSubmit } from '~/dashboard/utils'

import { RequestResetPasswordDialogProps } from './index'

const formClasses = {
  rowWrapper: 'flex flex-col',
  labelElement: 'flex flex-col',
}

const TEXT = {
  email: 'E-Mail',
  send: 'Senden',
  alertTitle: 'Fast geschafft: Prüfe nun deine E-Mail',
  alertDescription:
    'Prüfe nun deine E-Mail-Inbox und folge den Anleitungen, um ein neues Passwort einzugeben.',
  okay: 'Alles klar',
}

export const RequestRestPasswordDialog = ({
  isOpen,
  onClose,
  isSuccess,
  textContent,
  email,
}: RequestResetPasswordDialogProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const submit = useSubmit()

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const formData = new FormData(e.currentTarget)
    setIsSubmitting(true)

    const captchaToken = await recaptchaPrecheckSubmit(
      ChangePasswordEnum.REQUEST_RESET_PASSWORD,
    )
    if (!captchaToken) {
      setIsSubmitting(false)
      return
    }

    formData.set('_captcha', captchaToken)

    await submit(formData, { method: 'post' })
    setIsSubmitting(false)
  }

  return (
    <Dialog isOpen={isOpen} onClose={onClose} size={'xl'}>
      <DialogTitleWithCloseButton
        title={textContent.headline}
        onClose={onClose}
      />
      <Description className='text-body2'>
        {textContent.description}
      </Description>
      <Form method='post' onSubmit={handleSubmit}>
        <div className={formClasses.rowWrapper}>
          <div className={'my-6'}>
            <Input
              type={'email'}
              name={'email'}
              required
              readOnly={!!email}
              placeholder={TEXT.email}
              disabled={isSuccess}
              defaultValue={email}
            />
          </div>
          {isSuccess ? (
            <Alert
              level={'success'}
              title={TEXT.alertTitle}
              className='mb-5 py-5'
              key='success'
            >
              <div className='flex flex-col items-start gap-4'>
                <p className='text-body2 text-yellow-900'>
                  {TEXT.alertDescription}
                </p>
                <Button
                  className={'border-none bg-white'}
                  variant='ghost'
                  onClick={onClose}
                >
                  {TEXT.okay}
                </Button>
              </div>
            </Alert>
          ) : (
            <ActionBar
              classes={'w-1/2'}
              intent={ChangePasswordEnum.REQUEST_RESET_PASSWORD}
            >
              <ContinueButton disabled={isSuccess || isSubmitting}>
                {TEXT.send}
              </ContinueButton>
              <CancelButton onClick={onClose} />
            </ActionBar>
          )}
        </div>
      </Form>
    </Dialog>
  )
}
